import { useContext } from "react";

import { ChaseInstantCreditContext } from "./ChaseInstantCreditProvider";

export const useChaseInstantCredit = () => useContext(ChaseInstantCreditContext) ?? {};
